<template>
  <v-container style="max-width:100vw;">
      <v-data-table
        :headers="headers"
        :items="formattedItems"
        :loading="loading"
        class="elevation-0 px-6 py-4"
        :items-per-page="10"
      >
        <template v-slot:top>
            <v-toolbar flat >
                <v-row class="ma-0">
                    <v-toolbar-title>Saldos Vencidos</v-toolbar-title>
                </v-row>
            </v-toolbar>
        </template>
        <template v-slot:item.cero="{ item }">
          {{ toCurrency(item.cero) }}
        </template>
        <template v-slot:item.treinta="{ item }">
          {{ toCurrency(item.treinta) }}
        </template>
        <template v-slot:item.sesenta="{ item }">
          {{ toCurrency(item.sesenta) }}
        </template>
        <template v-slot:item.noventa="{ item }">
          {{ toCurrency(item.noventa) }}
        </template>
        <template v-slot:item.total="{ item }">
          <strong>{{ toCurrency(item.total) }}</strong>
        </template>

        <template v-slot:footer>
            <div style="position: absolute;" class="ma-5">
                <!--v-select :items="sumavg" v-model="totalType" style="width: 100px; display: inline-block; margin-right:30px; font-size: 14px;"></v-select>
                <v-select :items="campos" v-model="campo" item-text="text" item-value="value" style="width: 100px; display: inline-block; margin-right:30px; font-size: 14px;"></v-select-->
                <strong>Total = {{ toCurrency(total) }}</strong><!--v-if="totalType=='sum'"-->
                <!--strong v-if="totalType=='avg'">Promedio = {{ avgField(campo) }}</strong-->
            </div style="position: absolute;" class="ma-5">
        </template> 
      </v-data-table>
  </v-container>
</template>

<script>
import axios from "axios"

export default {
  data() {
    return {
      loading: false,
      items: [],
      total:0
    };
  },
  computed: {
    headers() {
      return [
        { text: "Cliente", value: "client" },
        { text: "+0 días vencido", value: "cero" },
        { text: "+30 días vencido", value: "treinta" },
        { text: "+60 días vencido", value: "sesenta" },
        { text: "+90 días vencido", value: "noventa" },
        { text: "Total", value: "total" },
      ];
    },
    formattedItems() {
      return this.items.map(i => ({
        client: i.Cliente,
        cero: Number(i["+0 días"]),
        treinta: Number(i["+30 días"]),
        sesenta: Number(i["+60 días"]),
        noventa: Number(i["+90 días"]),
        total: Number(i["Total"]),
      }));
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      axios
        .get(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/collection/past_due")
        .then(res => {
          this.items = res.data.data;
          this.total = res.data.total_general
        })
        .catch(err => {
          console.error("Error cargando cartera vencida:", err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    toCurrency(value) {
      return Number(value).toLocaleString("es-MX", {
        style: "currency",
        currency: "MXN",
      });
    },
  },
};
</script>
